// extracted by mini-css-extract-plugin
module.exports = {"root":"BackToTop_root__A5Kve","shown":"BackToTop_shown__9yqcX","button":"BackToTop_button___hKRX","messageSvg":"BackToTop_messageSvg__fjokG"};